import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import nandiNirvana1 from "../assets/nandiNirvana1.jpeg";
import nandiNirvana2 from "../assets/nandiNirvana2.jpeg";
import nandiNirvana3 from "../assets/nandiNirvana3.jpeg";
import nandiNirvana4 from "../assets/nandiNirvana4.jpeg";
import nandiNirvana5 from "../assets/nandiNirvana5.jpeg";
import nandiNirvana6 from "../assets/nandiNirvana6.jpeg";
import nandiNirvana7 from "../assets/nandiNirvana7.jpeg";
import nandiNirvana8 from "../assets/nandiNirvana8.jpeg";
import nandiNirvana9 from "../assets/nandiNirvana9.jpeg";
// import varaprabhaEnclave1 from "../assets/VaraprabhaEnclave1.jpeg";
import varaprabhaEnclave2 from "../assets/ve2.jpeg";
import varaprabhaEnclave3 from "../assets/ve3.jpeg";
import varaprabhaEnclave4 from "../assets/ve4.jpeg";

// import farmLand1 from "../assets/farmLand1.jpeg";
// import farmLand2 from "../assets/farmLand2.jpeg";
// import farmLand3 from "../assets/farmLand3.jpeg";

const projectsData = {
  ongoing: [
    {
      name: "Varapradha Enclave",
      description:
        "We are excited to introduce our new project, designed specifically to help customers looking in North Bangalore.\n\n✨ What is it?\nVarapradha Enclave offers the perfect balance of connectivity, growth, and lifestyle in North Bangalore’s rapidly developing corridor.\n\n💡 Why you’ll love it:\n1] CUDA approved ✅\n2] 'A' Katha ✅\n3] Bank Loan Available ✅\n4] Ready for Registration & construction ✅",
      data: "",
      images: [varaprabhaEnclave3, varaprabhaEnclave4, varaprabhaEnclave2],
      // images: [],
    },
  ],
  upcoming: [
    {
      name: "A Dreamly Farmland",
      description: "Future-ready\n homes with state-of-the-art\n amenities.",
      data: "",
      // images: [farmLand1, farmLand2, farmLand3],
      images: [],
    },
  ],
  completed: [
    {
      name: "Advaitha Nandhi Nirvana",
      description:
        "At Kundana Devanahalli\n8+ amenities\n1200 Sq Ft plots\nReady to build plots",
      data: "",
      images: [
        nandiNirvana1,
        nandiNirvana2,
        nandiNirvana3,
        nandiNirvana4,
        nandiNirvana5,
        nandiNirvana6,
        nandiNirvana7,
        nandiNirvana8,
        nandiNirvana9,
      ],
    },
  ],
};

const ResidentialProperties = () => {
  const [activeTab, setActiveTab] = useState("ongoing");
  const [currentProject, setCurrentProject] = useState(0);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentProject(0);
  };

  const activeProjects = projectsData[activeTab];
  const whatsappMessage = `https://wa.me/919900097989?text=Hello%20Advaitha%0ACan%20I%20have%20your%20${encodeURIComponent(
    activeProjects[currentProject].name
  )}%20Brochure`;

  return (
    <section id="residential-projects" className="container mx-auto py-16 px-4">
      <h2 className="text-center mb-8">
        <span className="text-4xl md:text-5xl font-extrabold text-primary">
          OUR PROJECTS
        </span>
      </h2>

      {/* Tabs */}
      <div className="flex justify-center space-x-6 mb-8">
        {["ongoing", "upcoming", "completed"].map((tab) => (
          <button
            key={tab}
            onClick={() => handleTabClick(tab)}
            className={`px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-semibold transition ${
              activeTab === tab
                ? "bg-primary text-white"
                : "bg-gray-200 text-gray-700 hover:bg-primary hover:text-white"
            }`}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {/* Project Details */}
      <div className="flex flex-col-reverse md:flex-row items-center">
        {/* Left Side - Text */}
        <div className="w-full md:w-1/2 p-4 flex items-center justify-center">
          <div className="text-center md:text-left max-w-lg">
            <h3 className="text-2xl font-bold mb-4 text-primary">
              {activeProjects[currentProject].name}
            </h3>
            <p className="text-gray-700 mb-4 whitespace-pre-line text-lg leading-relaxed">
              {activeProjects[currentProject].description}
            </p>
            <p className="text-lg text-gray-500">
              {activeProjects[currentProject].data}
            </p>
            <a
              href={whatsappMessage}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-dark transition"
            >
              Download Brochure
            </a>
          </div>
        </div>

        {/* Swiper.js Carousel */}
        <div className="w-full md:w-3/5 p-2 md:p-4">
          <Swiper
            pagination={{ clickable: true }}
            navigation
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            modules={[Pagination, Navigation, Autoplay]}
            className="w-full max-w-xl md:max-w-3xl mx-auto"
          >
            {activeProjects[currentProject].images.map((img, index) => (
              <SwiperSlide key={index} className="flex justify-center">
                <img
                  src={img}
                  alt={`${activeProjects[currentProject].name} - ${index + 1}`}
                  className="w-full max-w-full h-[18rem] md:h-[30rem] object-cover rounded-lg shadow-lg"
                  onError={(e) => (e.target.src = "/placeholder.jpg")}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <style>
            {`
    .swiper-pagination-bullet {
      background-color: white !important;
    }
    .swiper-button-prev,
    .swiper-button-next {
      color: white !important;
    }
  `}
          </style>
        </div>
      </div>
    </section>
  );
};

export default ResidentialProperties;
